import actions from './actions'
import mutations from './mutations'
import defaultState from './defaultState'
import getters from './getters'

export default {
  namespaced: true,
  actions,
  mutations,
  state: defaultState(),
  getters,
}
